module.exports = __webpack_public_path__ + "img/21.05d7aebc.png";